module.exports = __webpack_public_path__ + "85a9fe67d90aa8edba1b3e8029b904db.woff2";